import(/* webpackMode: "eager" */ "/home/oreetiene/test.adi-mag.ro/node_modules/next/dist/client/link.js");
